import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ColumnFilter, ColumnSort } from "@tanstack/react-table";
import { INITIAL_PAGING, STATUS_INITIAL, STATUS_LOADING, STATUS_SUCCEEDED } from "myParkdUtils/constants";
//import { defaultSortingOffstreetSessions } from "screens/parkingSessions/ParkingSessionsScreen";
import { SessionDTOExtended, PagingReactTable, Status } from "types";

export const defaultSortingOffstreetSessions: ColumnSort[] = [{ id: 'endTime', desc: true }];

export type OffstreetSessionsState = {
    sessions: SessionDTOExtended[];
    paging: PagingReactTable;
    status: Status;
    exportFilters: ColumnFilter[];
    exportSorting: ColumnSort[];
};

export const initialState: OffstreetSessionsState = {
    sessions: [],
    paging: INITIAL_PAGING,
    status: STATUS_INITIAL,
    exportFilters: [],
    exportSorting: defaultSortingOffstreetSessions
};


export const offstreetSessionsSlice = createSlice({
    name: 'offstreetSessions',
    initialState,
    reducers: {
        getOffstreetSessions(state, action: PayloadAction<{ paging: PagingReactTable, filters?: ColumnFilter[], sorting?: ColumnSort[] }>) {
            state.status = STATUS_LOADING;
            state.sessions = [];
            state.exportFilters = action.payload.filters!;
            state.exportSorting = action.payload.sorting!;
        },
        getOffstreetSessionsCompleted(state, action: PayloadAction<{ sessions: SessionDTOExtended[], totalElements: number, totalPages: number }>) {
            state.status = STATUS_SUCCEEDED;
            state.sessions = action.payload.sessions;
            state.paging.totalElements = action.payload.totalElements;
            state.paging.totalPages = action.payload.totalPages;
        },
        getOffstreetSessionsError(state, action: PayloadAction<{ error: any }>) {
            state.status = {
                ...STATUS_INITIAL,
                error: action.payload.error
            }
        }
    }
});

export const offstreetSessionsSliceActions = offstreetSessionsSlice.actions;

export default offstreetSessionsSlice.reducer;